import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import styles from "./footer.module.scss";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import markerRetina from "leaflet/dist/images/marker-icon-2x.png";
import L from "leaflet";
const customMarker = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerRetina,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const Map = () => {
  return (
    <MapContainer
      center={[35.760073, 51.413388]}
      zoom={15}
      scrollWheelZoom={false}
      zoomControl={false}
      className={styles.map}
    >
      <TileLayer url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}" />
      <Marker icon={customMarker} position={[35.760073, 51.413388]}>
        <Popup>
          <a href="https://maps.app.goo.gl/19qTKnGaF5q4nNVy9"> ArayehCo.com</a>
        </Popup>
      </Marker>
    </MapContainer>
  );
};
